<script>
import { get, keyBy } from 'lodash'
import moment from 'moment'

export default {
  data() {
    return {
      districts: [],
      filters: {
        available: [
          {
            name: 'Dzielnica',
            query_param: 'district',
            options: this.setDistrictOptions
          },
          {
            name: 'Od dnia',
            query_param: 'created__gte',
            date: true
          },
          {
            name: 'Do dnia',
            query_param: 'created__lte',
            date: true
          }
        ],
        selected: {}
      }
    }
  },
  computed: {
    districtMap() {
      return keyBy(this.districts, 'value')
    }
  },
  methods: {
    setDistrictOptions(options) {
      this.service
        .availableDistricts()
        .then(response => {
          this.districts = response.data
          options.push(...response.data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    getLabel(map, value) {
      const labelFound = map.hasOwnProperty(value)
      return (labelFound && map[value].label) || value
    },
    getDistrictLabel(instance) {
      return this.getLabel(this.districtMap, instance.district)
    }
  }
}
</script>
